import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ExpirationsStyle from './css/ExpirationsStyle'
import { dateYMD } from '../../../../utilities/utilities'

function Expirations(props) {
  const { invoiceParticular, cb, pullOut } = props
  const [expirationDate, setExpirationDate] = useState('')

  const onClickClose = (e) => {
    cb('Close')
  }

  const onClickApply = (e) => {
    invoiceParticular.expiration_date = expirationDate
    cb('Apply')
  }

  const onClickExpirationDate = (e) => {
    // Uncheck expiration dates which are note selected
    const uncheckNotSelectedExpDate = () => {
      const exp_dates_container = document.getElementById('expiration-dates-container')
      const checks_marks = exp_dates_container.querySelectorAll('.check-mark')
      checks_marks.forEach(cm => {
        if (cm.classList.contains('show-check-mark'))
          cm.classList.remove('show-check-mark')
      })
    }

    // Check selected date
    const checkSelectedExpDate = () => {
      const exp_date = e.target.closest('.expiration-date')
      const check_mark = exp_date.querySelector('.check-mark')
      if (!check_mark.classList.contains('show-check-mark')) {
        check_mark.classList.add('show-check-mark')
        setExpirationDate(exp_date.id)
      }
    }

    uncheckNotSelectedExpDate()
    checkSelectedExpDate()
  }

  return (
    <React.Fragment>
      <div id='expirations-container'>
        <div id='item-name'>
          {
            (pullOut)
            ? <div>Select {invoiceParticular.item_name} <i>{invoiceParticular.unit}</i> expiration date.</div>
            : <div>
                {`Pull-out ${invoiceParticular.quantity} ${invoiceParticular.unit} of `}
                <span><i>{invoiceParticular.item_name}</i></span>
              </div>
          }
        </div>
        <div id='expiration-dates-container'>
        {
          invoiceParticular.expirations
          .map((exp, i) => (
            <button
              key={i}
              id={dateYMD(new Date(exp.date))}
              onClick={onClickExpirationDate}
              disabled={(exp.quantity < invoiceParticular.quantity)}
              className={invoiceParticular.expirations.length === (i + 1)
                ? (exp.quantity < invoiceParticular.quantity)
                  ? 'expiration-date last-exp-date'
                  : 'top-anchor expiration-date active last-exp-date'
                : (i === 0)
                  ? (exp.quantity < invoiceParticular.quantity)
                   ? 'expiration-date'
                   : 'top-anchor expiration-date active'
                  : (exp.quantity < invoiceParticular.quantity)
                   ? 'expiration-date'
                   : 'top-anchor expiration-date active'
              }>
              <div className='exp-date-data'>
                <div><b>{exp.unit}</b></div>
                <div>Expiration Date: {dateYMD(new Date(exp.date))}</div>
                <div>Inventory: {exp.quantity}</div>
              </div>
              <div className='check-mark-container'>
                <div className='check-mark'>
                  <FontAwesomeIcon icon='check'/>
                </div>
              </div>
            </button>
          ))
        }
        </div>
        <div id='expiration-button-container'>
          <button
            onClick={onClickClose}
            className='top-anchor pospro-action-btn'>
            Close
          </button>
          <button
            id='exp-date-btn-apply'
            disabled={(expirationDate === '')}
            onClick={onClickApply}
            className='bottom-anchor pospro-action-btn'>
            Apply
          </button>
        </div>
      </div>
      <ExpirationsStyle />
    </React.Fragment>
  )
}

export default React.memo(Expirations)
